import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wageReportDiv" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "개선 전 합계금액 수동조정", -1)

import AdminLoadingAction from '../layout/AdminLoadingAction.vue'
import { useStore } from 'vuex';
import axios from 'axios';
import { onMounted, ref, watch, reactive } from 'vue';

interface JogunItem {
  yeon: string;
  gun: string;
  jang: string;
  go: string;
  so: string;
  ji: string;
  jiwon: string;
  sil: string;
  san: string;
  out: string;
}

interface Field {
  label: string;
  model: keyof JogunItem;
}

interface WageItem {
  [key: string]: string | number;
}

interface SojiItem {
  code: string;
  name: string;
  value: string;
}

interface TaxItem {
  code: string;
  name: string;
  value: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageReport',
  setup(__props) {

const store = useStore();
const loading = ref(false);
const code = ref<string>(store.state.AdminSisulCode);
const bizGubun = ref<string>(store.state.AdminBizGubun);
const sisulName = ref<string>(store.state.AdminSisulName);
const date = ref<string>(store.state.AdminYYMM);

const fields: Field[] = [
  { label: '국민연금', model: 'yeon' },
  { label: '건강보험', model: 'gun' },
  { label: '장기요양', model: 'jang' },
  { label: '고용보험', model: 'go' },
  { label: '소득세', model: 'so' },
  { label: '지방세', model: 'ji' },
  { label: '지원공제', model: 'jiwon' },
  { label: '실업(사)', model: 'sil' },
  { label: '산재(사)', model: 'san' },
  { label: '퇴직(사)', model: 'out' },
];

const jogunList = reactive<JogunItem>({
  yeon: '',
  gun: '',
  jang: '',
  go: '',
  so: '',
  ji: '',
  jiwon: '',
  sil: '',
  san: '',
  out: '',
});
const wageList = ref<WageItem[]>([]);
const soji = ref<SojiItem[]>([]);
const tax = ref<TaxItem[]>([]);

function clearFormat(item: WageItem, key: string) {
  // 인풋의 값을 컴마 없이 만듭니다.
  item[key] = unformatNumber(item[key]);

  // 값이 0이면 빈 값으로 설정하여 placeholder를 보이도록 합니다.
  if (item[key] === '0' || item[key] === 0 || item[key] === '-0') {
    item[key] = '';
  }
}

function applyFormat(item: WageItem, key: string) {
  // 값이 비어있으면 0으로 설정
  if (item[key] === '' || item[key] === null || item[key] === undefined || item[key] === '-0') {
    item[key] = '';
  } else {
    // 포커스가 해제되면 천 단위로 컴마를 추가
    item[key] = formatNumber(item[key]);
  }
}

function formatNumber(value: string | number): string {
  // 숫자인지 확인하고 천 단위로 컴마 추가
  const number = parseFloat(value.toString());
  if (!isNaN(number)) {
    return number.toLocaleString();
  }
  return value.toString();
}

function unformatNumber(value: string | number): string {
  // 컴마를 제거
  return value.toString().replace(/,/g, '');
}

const empWageCalc = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/api/empWageCalc/${code.value}/${date.value}/${bizGubun.value}/${sisulName.value}`);
    const responseData = response.data;
    if (responseData) {
      wageList.value = responseData.result;
      soji.value = responseData.soji;
      tax.value = responseData.tax;
      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  } finally {
    loading.value = false;
  }
};

watch(
  () => store.state.AdminYYMM,
  (newValue) => {
    if (newValue) {
      date.value = newValue;
      empWageCalc();
    }
  }
);

const getWageReportPdf = async () => {
  try {
    // 서버로부터 PDF 데이터를 요청
    const response = await axios.post(
      "/api/getWageReportPdf",
      { wageList: wageList.value },
      {
        responseType: "json",
      }
    );

    // 서버로부터 받은 데이터에서 PDF Base64 문자열 추출
    const pdfBase64 = response.data.pdf;

    // Base64 문자열을 이진 데이터로 변환
    const binaryString = window.atob(pdfBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // 이진 데이터로부터 Blob 생성
    const blob = new Blob([bytes], { type: "application/pdf" });

    // Blob URL 생성
    const url = window.URL.createObjectURL(blob);

    // 새 창에서 PDF 열기
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("새 창을 열 수 없습니다. 팝업 차단 설정을 확인하세요.");
    }
  } catch (error) {
    console.error("PDF 미리보기 중 에러 발생:", error);
  }
};

onMounted(async () => {
  await empWageCalc();
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (loading.value)
    ? (_openBlock(), _createBlock(AdminLoadingAction, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            onClick: getWageReportPdf,
            class: "fontNotoSans500"
          }, {
            default: _withCtx(() => [
              _createTextVNode("임금대장보고서.pdf")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
            return _createVNode(_component_v_text_field, {
              key: field.model,
              type: "text",
              modelValue: jogunList[field.model],
              "onUpdate:modelValue": ($event: any) => ((jogunList[field.model]) = $event),
              label: field.label,
              class: "wageReportJogunInput",
              onFocus: ($event: any) => (clearFormat(jogunList, field.model)),
              onBlur: ($event: any) => (applyFormat(jogunList, field.model)),
              "hide-details": "auto",
              density: "compact",
              maxlength: "11",
              color: "indigo",
              variant: "outlined"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onFocus", "onBlur"])
          }), 64))
        ])
      ], 64))
}
}

})